import store from '../store'

export default async (to, from, next) => {
  await store.dispatch('ui/ActionSetLoading', true)
  if (to.name != 'Login' && !store.getters['auth/GET_token']) {
    try {
      await store.dispatch('auth/ActionCheckToken')

      await store.dispatch('utils/ActionSetStates')
      if (to.name == 'invoice' || to.name == 'home') {
        await store.dispatch('acquisitions/ActionSetInvoices', {}, { root: true })
        await store.dispatch('acquisitions/ActionSetInvoicesItems', {}, { root: true })
        await store.dispatch('assets/ActionSetAssets', {}, { root: true })
      }
      if (to.name == 'transfer') {
        await store.dispatch('assets/ActionSetAssets', {}, { root: true })
        await store.dispatch('movements/ActionSetMovements', {}, { root: true })
      }
      document.title = `${to.name} :: IPH - Sistemas`
      next({ name: to.name })
    } catch (error) {
      next({ name: 'Login' })
      document.title = `${to.name} :: IPH - Sistemas`
    }
  } else {
    if (to.name == 'Login' && store.getters['auth/GET_token']) {
      next({ name: 'Home' })
      document.title = `${to.name} :: IPH - Sistemas`
    } else if (to.name == 'Login' && !store.getters['auth/GET_token']) {
      next()
    } else {
      document.title = `${to.name} :: IPH - Sistemas`
      store.dispatch('auth/ActionProfile')
      if (to.name == 'invoice' || to.name == 'home') {
        await store.dispatch('acquisitions/ActionSetInvoices', {}, { root: true })
        await store.dispatch('acquisitions/ActionSetInvoicesItems', {}, { root: true })
        await store.dispatch('assets/ActionSetAssets', {}, { root: true })
      }

      if (to.name == 'transfer') {
        await store.dispatch('assets/ActionSetAssets', {}, { root: true })
        await store.dispatch('movements/ActionSetMovements', {}, { root: true })
      }
      next()
    }
  }
  await store.dispatch('ui/ActionSetLoading', false)
}
